<template>
    <router-view></router-view>
</template>

<style lang="less">
</style>

<!-- 移除右侧滚动条 -->
<style lang="scss">
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
</style>

